// Search functionality for header search inputs
(function() {
  'use strict';

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Initialize search functionality
  function initSearchFunctionality() {
    console.log('Initializing search functionality...');

    // Handle search icon clicks
    const searchIcons = document.querySelectorAll('.show-search-input__icon');
    searchIcons.forEach(icon => {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the parent form
        const form = this.closest('form');
        if (form) {
          const searchInput = form.querySelector('.show-search-input__text');
          const searchQuery = searchInput ? searchInput.value.trim() : '';
          
          // Only submit if there's a search query
          if (searchQuery.length > 0) {
            console.log('Submitting search for:', searchQuery);
            form.submit();
          } else {
            // Focus the input if empty
            if (searchInput) {
              searchInput.focus();
            }
          }
        }
      });
      
      // Make icon look clickable
      icon.style.cursor = 'pointer';
    });

    // Handle Enter key press on search inputs
    const searchInputs = document.querySelectorAll('.show-search-input__text');
    searchInputs.forEach(input => {
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          
          const searchQuery = this.value.trim();
          
          // Only submit if there's a search query
          if (searchQuery.length > 0) {
            console.log('Enter pressed, submitting search for:', searchQuery);
            const form = this.closest('form');
            if (form) {
              form.submit();
            }
          }
        }
      });
    });

    // Also handle mobile search input if it exists
    const mobileSearchInput = document.querySelector('.logo-area__search--input input[name="q"]');
    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          
          const searchQuery = this.value.trim();
          
          if (searchQuery.length > 0) {
            console.log('Mobile search - Enter pressed, submitting search for:', searchQuery);
            const form = this.closest('form');
            if (form) {
              form.submit();
            }
          }
        }
      });
      
      // Handle mobile search icon click
      const mobileSearchButton = document.querySelector('.logo-area__search--input button[type="submit"]');
      if (mobileSearchButton) {
        mobileSearchButton.addEventListener('click', function(e) {
          const searchQuery = mobileSearchInput.value.trim();
          
          if (searchQuery.length === 0) {
            e.preventDefault();
            mobileSearchInput.focus();
          }
        });
      }
    }

    console.log('Search functionality initialized successfully');
  }

  // Initialize when DOM is ready
  ready(initSearchFunctionality);
})();

